import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import CollectionsIcon from "@mui/icons-material/Collections";

export default function AvatarPerfil({ avatar, aoClicarEditar }) {
  const styles = {
    flexRow: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    avatarBadge: {
      position: "relative",
    },
  };

  return (
    <div>
      <div style={styles.flexRow}>
        <div style={styles.avatarBadge}>
          <Avatar sx={{ width: 260, height: 260 }} src={avatar} />
          <IconButton
            onClick={aoClicarEditar}
            sx={{
              position: "absolute",
              bottom: 0,
              right: 0,
              backgroundColor: "var(--cor-roxoEscuro)",
              border: "4px solid white",
              width: 70,
              height: 70,
              "&:hover": { backgroundColor: "var(--cor-roxoApoio)" },
            }}
          >
            <CollectionsIcon sx={{ width: 30, height: 30, color: "white" }} />
          </IconButton>
        </div>
      </div>
    </div>
  );
}